var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status === 'PENDING')?_c('s-tag',{staticClass:"pending"},[_vm._v("Pending")]):(_vm.status === 'IN_PROGRESS')?_c('s-tag',{attrs:{"is-progress":""}},[_vm._v("In progress")]):(_vm.status === 'DONE')?_c('s-tag',{attrs:{"is-done":""}},[_vm._v("Done")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }